import * as React from "react";
import IAccessDeniedProps from "./IAccessDenied";
import "../../../assets/sass/widgets/accessdenied.scss";

/**
 * @class AccessDenied
 * @param {string} type - Type of denied
 * @param {string} message - Access Denied Message
 * @param {function} alertBoxClose - Function of onClose click
 * @description Shows popup message for unauthorized user
 * @category Widgets
 */
const AccessDenied: React.FC<IAccessDeniedProps> = ({ type, message, alertBoxClose }) => {
    return (
        <React.Fragment>
            <div>
                <div className="denied-overlay">
                    <div className={"access-denied-container " + type}>
                        <div className="access-denied-header">
                            <div className="icon-close" onClick={alertBoxClose}>
                                &times;
                            </div>
                            <div className="access-denied-title">Access Denied</div>
                        </div>
                        <div className="access-denied-message">{message}</div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AccessDenied;
